module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-No-Pagebreak"
  }, [_vm._v("DRAMATIS PERSONAE")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("Tom Haring: Producer, Moonthunder Records; Windhollow Faire’s Manager")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("Windhollow Faire: ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Lesley Stansall: Lead singer/songwriter")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Ashton Moorehouse: Bassist")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Jonathan Redheim: Drums, percussion")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("William Fogerty: Rhythm guitar, fiddle, mandolin")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Julian Blake (deceased): Singer/songwriter, lead guitar")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("Patricia Kenyon: Journalist/Music critic")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("Nancy O’Neill: Professional psychic")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("Billy Thomas: Photographer, estate agent")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14410e4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled13.vue
// module id = 78
// module chunks = 0